var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"title":_vm.dateObj.toLocaleString()},on:{"click":_vm.copyIsoDate}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.distance)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }